import React, {useEffect} from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

const HappyClient = () => {

    useEffect(() => {
      AOS.init();
      AOS.refresh();
    }, []);


  return (
    <>
      <section className="my-10 ">
        <div className="w-screen h-[450px] ">
          <div className="w-screen flex justify-center items-center h-[450px] lg:h-[500px]">
            <p data-aos="fade-up" data-aos-duration="2000" className="text-4xl sm:text-5xl absolute container mx-auto uppercase w-11/12 sm:w-9/12 text-right leading-[60px] font-medium text-opacity-70 text-white lg:text-6xl z-40">
              Your Satisfaction is Our Priority
            </p>
            <div className="imgbg w-full h-full brightness-[0.2]"></div>
          </div>
        </div>
      </section>
    </>
  );
}

export default HappyClient